import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface ConfirmDeleteTVShowModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  showTitle: string;
}

const ConfirmDeleteTVShowModal = ({
  show,
  onHide,
  onConfirm,
  showTitle,
}: ConfirmDeleteTVShowModalProps) => (
  <Dialog open={show} onClose={onHide} maxWidth="xs" fullWidth>
    <DialogTitle>Remove Show</DialogTitle>

    <DialogContent dividers>
      <Typography>
        Are you sure you want to remove <strong>{showTitle}</strong>? Your
        episode ticks will be lost.
      </Typography>
    </DialogContent>

    <DialogActions>
      <Button onClick={onHide}>Cancel</Button>
      <Button variant="contained" color="error" onClick={onConfirm}>
        Remove
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteTVShowModal;
